import { createContext } from 'react'

export type SegmentColumnsContextValue = {
  segments: { id: string; label: string }[]
  segmentIdsByColumn: Record<number, string[]>
  onChange: (columnIndex: number, segmentIds: string[]) => void
}

export const SegmentColumnsContext =
  createContext<SegmentColumnsContextValue | null>(null)
